import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { images } from "./images";
import { RoomAfterEventsBTNS, RoomAfterRecapBTNS } from "./V3";


export const JoeGym1 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym1, { transition: true });
    mc.think(`The gym...`);
    mc.think(`I never thought Joey would start coming here regularly.`);
    ImageClass.setImage(images.v3.JoeyGym2);
    mc.talk(`Hey Joey.`);
    joe.talk(`JOE!`);
    mc.talk(`Fine, Joe.`);

    ImageClass.setImage(images.v3.JoeyGym3);
    joe.talk(`Since you are here, do you wanna try and do some sets?`);
    mc.talk(`No, not really.`);


    ImageClass.setImage(images.v3.JoeyGym4);
    joe.talk(`Fine, so let me just put this down.`);

    ImageClass.setImage(images.v3.JoeyGym5);
    joe.talk(`It was crazy yesterday, wasn't it?`);
    mc.talk(`Yes it was.`);

    ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
    joe.talk(`Ann is really cute! I saw her yesterday for the first time in real life and I must say I expected less.`);

    ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
    mc.talk(`Why? Did Vanessa say bad things about her?`);

    ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
    joe.talk(`Vanessa has her own way to say things.`);

    if (mc.properties.annStatus === "natural") {
        if (!mc.properties.metAnn) {
            mc.think(`I can't tell him that was when I met her for the first time myself.`);
        }
        mc.think(`He has no idea I was with his girl instead of Ann.`);

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`I hope things are going well for you guys.`);

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`Are you going to meet again?`);

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.think(`I'd rather not tell the truth right away.`);
        mc.talk(`We'll see, I don't see a reason why not.`);
    } else if (mc.properties.annStatus === "hate") {
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`Since we have some time to talk, can you really explain to me what's going on with you and Ann?`);

        await joe.setQuestion(new Question({ text: `I know you've said you don't like her.\nBut why?`, key: `v3JoeGymWhyDislikeAnn` })
            .option({ title: `She is not freaky enough`, key: `notFreaky` })
            .option({ title: `She is ugly`, key: `sheIsUgly` })
            .option({ title: `I want a girl like Vanessa`, key: `IWantVanessa` })
            .option({ title: `I've changed my mind, I want her`, key: `IChangedMyMind` })
            .option({ title: `I don't really know why`, key: `dunno` }));


        if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "notFreaky") {
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`She is not freaky enough.`);
            joe.talk(`Oh! So you want a freaky girl?`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`Exactly.`);
            joe.talk(`You can't know how she is like in bed.`);
            joe.talk(`I bet you didn't have sex yet.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`Far from that.`);
            joe.talk(`At the end of the day you do what you think is best.`);
            joe.talk(`But between us, I think that's a mistake.`);
            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
                ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
                joe.talk(`In any case, it seems like she likes that Chris guy.`);
                joe.talk(`At least that's what she said yesterday.`);
                joe.talk(`So someone is interested in her.`);
            }

        } else if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "sheIsUgly") {
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`She is ugly.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`Ugly?\nWhat are you talking about?`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`She is really hot! You can't see it with all those layers she has on.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`How can you tell?\nDo you have x-ray vision?`);
            joe.talk(`I have a gift, haha.`);
            joe.talk(`Anyway, there is nothing to do about that if you think she is ugly.`);
            joe.talk(`I hope the next girl you meet will look better to you.`);

            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
                ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
                joe.talk(`In any case, it seems like she likes that Chris guy.`);
                joe.talk(`At least that's what she said yesterday.`);
                joe.talk(`So someone finds her attractive.`);
                joe.talk(`Besides me haha.`);
            }

        } else if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "IWantVanessa") {
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`I want a girl like Vanessa.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`Yeah Vanessa is one of a kind!`);
            joe.talk(`Good luck finding someone like that.`);
            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
                ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
                joe.talk(`In any case, it seems like she likes that Chris guy.`);
                joe.talk(`At least that's what she said yesterday.`);
                joe.talk(`So someone is interested in her.`);
            }

        } else if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "dunno") {
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`I don't really know why.`);

            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`I can't put my finger on it but there is something there.`);

            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`If you can't say it, it's bullshit.`);

            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
                ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
                joe.talk(`In any case, you will need to work hard for that.`);
                joe.talk(`Because she likes that Chris guy.`);
                joe.talk(`At least that's what she said yesterday.`);
            }

        } else {
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`I've changed my mind, I want her.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`Very nice!`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`I believe I can soften her up again.`);
            joe.talk(`I hope you succeed my man.`);

            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
                ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
                joe.talk(`You will need to work hard for that now.`);
                joe.talk(`Because she is into that Chris guy.`);
                joe.talk(`At least that's what she said yesterday.`);

            } else {
                ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
                joe.talk(`You will need to work hard for that now.`);
                joe.talk(`Because she is really pissed at you.`);
            }
        }

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`You should go and talk to her.`);
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        mc.talk(`I don't think it's a good idea just yet.`);
        joe.talk(`Dude, trust me. Just do it.`);
        mc.talk(`I don't think she would want that.`);
        mc.talk(`Besides, I already listened to you yesterday, you insisted that I invite her.`);

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`That's true.`);
        joe.talk(`Well, I trust you in any case.`);
        joe.talk(`If you need anything just hit me up.`);
        mc.talk(`Thank Joey.`);


    }


    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`I really like Ann, I'm going to invite her over once we are done here.`);

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`You little devil!`);

        if (Question.globalAnswers.afterTODEnteredNaked) {
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`I hope she'll be interested after what happened this morning.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`Sleeping next to her naked was funny, but she might be upset now.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`I'll tell her it was a joke.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`And Vanessa said she will talk to her.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`I am sure she will understand.`);
        }
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`I just hope it won't be just talking again.`);

        if (Question.globalAnswers.v2KissedAnn) {

            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`I mean, we kissed last time, but we aren't in first grade anymore.`);
        }
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`So demand more.`);
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`I want to, but she wants to take it slow.`);
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`Listen, I know you might not need my advice.\nBut I'm gonna say it anyway.`);
        joe.talk(`Just show her that if she takes things REALLY slow, she is going to lose you.`);
        joe.talk(`She is crazy for you, I bet she will do whatever you want.\nYou just need to demand it.`);
        joe.talk(`Each time you meet, try to push a little further, if you see she starts to feel uncomfortable then stop.`);
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`Alright.`);

    }


    if (Question.globalAnswers.v25JoeTODAgree) {
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`Speaking of Ann.`);

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`I can't believe you kissed her in front of Vanessa.`);

        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        joe.talk(`Yes, haha.`);
        if (Question.globalAnswers.todBotheredByJoeKiss) {
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`You know... Seeing you two kiss kinda bothered me.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`I'm sorry dude, I didn't mean to upset you.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`That's ok, you asked for my permission and I did agree to it.`);
        }

        if (Question.globalAnswers.todGoRoomWith === "ann") {

            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`What were you doing with her in my room anyway?`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
            joe.talk(`Nothing really. We just talked, she loves talking.`);
            joe.talk(`What were you doing with Vanessa?`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
            mc.talk(`The same thing.`);
            ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p1);
        }
    }

    if (Question.globalAnswers.todMCDareVanessa === "showBoobs") {
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`I hope you aren't mad that I asked Vanessa to show me her boobs.`);
    } else {
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.talk(`I hope you aren't mad that I asked Vanessa to show me her panties.`);
        ImageClass.setImage(images.v3.JoeyGym5.partials.JoeyGym5_p2);
        mc.think(`Which she didn't have any...`);
    }

    return jump(JoeGym2, "JoeGym2");

};


export const JoeGym2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym5);
    joe.talk(`I'm not.`);
    mc.talk(`How are you so cool with that?`);
    joe.talk(`It's complicated.`);
    mc.talk(`What's so complicated about that?`);
    joe.talk(`I didn't want to talk about that just yet, but since you asked I'll do it.`);
    joe.talk(`Come, let's sit down and I'll explain everything.`);
    ImageClass.setImage(images.v3.JoeyGym6, { transition: true });
    joe.talk(`Ok, so...`);
    joe.talk(`I think you have a pretty good idea of how Vanessa is.`);
    joe.talk(`And like you saw, she has that spicy character of hers.`);
    joe.talk(`And like I've told you already, I've been with a few girls before meeting her.`);
    joe.talk(`The reason I've decided to be in a formal relationship with her is because she gives me everything I want.`);
    joe.talk(`She never says no to anything as long as I'm pleased.`);

    joe.talk(`But being with a girl like that comes with a price.`);
    joe.talk(`She really likes to tease people.`);
    joe.talk(`She uses her feminine wiles to control them.`);

    joe.talk(`But sometimes she goes too far.`);

    joe.talk(`And on top of all of that, she is a nympho.`);
    joe.talk(`If she doesn't get her daily sex, she will start looking in other directions.`);

    mc.talk(`How can you be ok with that?`);
    joe.talk(`I'll try to explain.`);
    joe.talk(`It's like when you see a hot girl on the street, walking around half-naked.`);
    joe.talk(`And you think to yourself: "Damn I wish I could be with her".`);


    return jump(JoeGym3, "JoeGym3");
};


export const JoeGym3 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym6, { transition: true });
    await joe.setQuestion(new Question({ text: `But when you have a girlfriend you don't want her to dress like that.`, key: `v3JoeGymAgreeForGFToDressLikeVanessa` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Disagree`, key: false }));


    if (Question.globalAnswers.v3JoeGymAgreeForGFToDressLikeVanessa) {
        mc.talk(`I agree.`);
        joe.talk(`I'm glad we are on the same page.`);
    } else {

        mc.talk(`I don't agree.`);
        joe.talk(`So maybe that's just me.`);
    }
    mc.talk(`I don't really see how that makes sense...`);
    joe.talk(`Give me a break, you know how I've always been bad with metaphors.`);
    joe.talk(`Anyway!\nI know Vanessa is a total slut.`);
    joe.talk(`And I know she might be fooling around with other people.`);

    joe.talk(`The reason I asked your permission to fool around with Ann was to see how she would react.`);
    if (Question.globalAnswers.v25JoeTODAgree) {

        mc.talk(`She didn't care.`);
        joe.talk(`Yeah.\nI wanted her to be on the other side for a change.`);
    } else {

        mc.talk(`I get it now.`);
        joe.talk(`I totally understand why you said no.`);
    }
    mc.talk(`Does that mean you have an open relationship?`);
    joe.talk(`Not exactly. An open relationship should be agreed on by both sides.`);
    joe.talk(`Because I know she fools around with other people, I don't mind doing the same.`);
    mc.talk(`Sounds like an open relationship to me.`);
    joe.talk(`It's more like mutual cheating...`);
    joe.talk(`But we do have one rule.`);
    joe.talk(`She can't sleep with someone I know.`);
    joe.talk(`If I found out that a guy I know touched her, I would kill him!`);
    joe.talk(`I know it's a lot to take in.`);
    joe.talk(`And I know it's unusual.\nBut you are my best friend, and I trust you to understand and accept it.`);
    mc.think(`Holy shit...`);
    mc.think(`Things aren't what they seem to be.`);
    mc.think(`They look so happy together, but Joey isn't totally pleased with the relationship.`);

    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        mc.think(`I don't know if he knows about her and Chris...`);
        mc.think(`I'll try to snoop and see if he does.`);
        mc.talk(`Maybe she stopped? Did she do it lately?`);
        joe.talk(`She did...`);
        joe.talk(`I'll tell you, but please keep it between us.`);
        joe.talk(`Remember the bar I told you about?`);
        joe.talk(`The one you went to with Ann?`);
        mc.think(`He doesn't even know I was there with Vanessa...`);
        mc.talk(`I remember.`);

        joe.talk(`I found out Vanessa did something with the bartender there...`);
        joe.talk(`I used to go there a lot, there was only a female bartender so he must be new...`);
        mc.talk(`How do you know?`);
        joe.talk(`She told me.`);
        mc.talk(`When?`);
        joe.talk(`A couple of days ago.`);
        if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt === false) {
            mc.think(`Good thing I backed off from blackmailing Vanessa, now I understand why she said I'm making a huge mistake.`);
            mc.think(`I don't think he knows she went there with me.`);
        } else if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
            mc.think(`What the fuck?`);
            mc.think(`Why the hell did she let me blackmail her if she already told him???`);
            mc.think(`I feel like the joke is on me.`);
            mc.think(`Yes, I did get a blowjob... But if I'll tell Joey right now, he'll kill me.`);
        } else if (mc.properties.vanessaStatus === "blackmailAttempt") {
            mc.think(`I tried to blackmail Vanessa.`);
            mc.think(`Good thing I didn't succeed, Joey knows everything.`);
            mc.think(`Well, almost everything... He doesn't know she went there with me.`);
        } else if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "dontHurtJoey") {
            mc.think(`Even though I went to the bar with Vanessa, I still want what's best for Joey.`);
            mc.think(`That's even what I said to Vanessa.`);
            // }

            mc.think(`I need to get more details out of him.`);
            mc.talk(`What exactly do you know?`);
            joe.talk(`I know only what she had told me.`);
            joe.talk(`She went there, ordered a few drinks and met that guy.`);

            mc.think(`I'm not sure if it's the best thing to confess about everything.`);
            mc.think(`I can just tell him that I was the one who went to the bar with Vanessa.`);
        }
        return jump(JoeGym3_Question, "JoeGym3_Question");
    } else {
        mc.talk(`Why didn't you tell me sooner?`);
        joe.talk(`It's been only a few days since you and I reunited.`);
        joe.talk(`We didn't talk for a year.`);
        joe.talk(`I came to your place looking all happy and kept telling you how you should embrace my lifestyle as well.`);

        if (Question.globalAnswers.v2_5JealousLifestyle) {

            joe.talk(`And that's why I asked you yesterday if you are jealous of me.`);
            joe.talk(`Once you said you were, I knew I had to talk to you and confess.`);
        }
        joe.talk(`I didn't want to sound like an idiot...`);
        mc.talk(`I get it.`);
        joe.talk(`That's why you are my best friend!`);
        mc.talk(`What are you going to do now?`);
        joe.talk(`With Vanessa?`);
        mc.talk(`Yes.`);
        joe.talk(`To be honest, lately she hasn't been with anyone else.`);
        mc.talk(`How do you know?`);
        joe.talk(`I asked her.`);
        mc.talk(`Do you believe her?`);
        joe.talk(`I have no reason not to, when she had done something she told me.`);
        mc.talk(`Have you been with anyone else since you got together?`);
        joe.talk(`I've told her I have, but it was a lie.`);
        joe.talk(`I said it after she had said she's been with someone.`);
        joe.talk(`I mean, I had opportunities. But I turned them down.`);
        joe.talk(`I really don't care about anyone else but her.`);
        mc.think(`Sounds like he is in love...`);
        return jump(JoeGym3ConfessClothesQuestion, "JoeGym3ConfessClothesQuestion");
    }

};
export const JoeGym3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym6, { transition: true });

    await mc.setQuestion(new Question({ text: `I can see how he reacts and then decide if I want to give out more information.`, options: { think: true }, key: `v3JoeGymTellAboutGoingBarWithVanessa` })
        .option({ title: `Tell him`, key: true })
        .option({ title: `Don't tell him`, key: false }));


    if (Question.globalAnswers.v3JoeGymTellAboutGoingBarWithVanessa) {
        return jump(JoeGym3Confess1, "JoeGym3Confess1");
    } else {
        return jump(JoeGym3DontConfess1, "JoeGym3DontConfess1");
    }

};

export const JoeGym3Confess1 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym6);
    mc.talk(`Joey, there is something I need to tell you.`);
    ImageClass.setImage(images.v3.JoeyGym7);
    joe.talk(`What is it?`);
    mc.talk(`I was the one who went with Vanessa to the bar...`);
    joe.talk(`What??`);
    joe.talk(`But you said you went with Ann!\nYou better explain!`);
    mc.talk(`I am, give me a moment.`);
    mc.talk(`So, after you sent me the bar address, I set up a date with Ann.`);
    mc.talk(`Then I got a call from Vanessa.`);
    mc.talk(`She said she wanted to meet.`);
    joe.talk(`Did she say why?`);
    mc.talk(`No, she said I have to meet her to find out.`);
    mc.talk(`I was too curious so I cancelled with Ann and met with her instead.`);

    joe.talk(`What the fuck dude? So everything you've told me about Ann was a lie?`);
    mc.talk(`It wasn't true but hear me out.`);

    mc.talk(`So I met up with her.`);
    await joe.setQuestion(new Question({ text: `What did she want from you?`, key: `v3JoeGymTellAboutBarGift` })
        .option({ title: `It was about your birthday`, key: true })
        .option({ title: `To get to know me`, key: false }));


    if (Question.globalAnswers.v3JoeGymTellAboutBarGift) {
        mc.talk(`She asked my help with choosing your gift for your birthday tomorrow.`);
        joe.talk(`Oh... That's not bad.`);
    } else {
        mc.talk(`She said she wants to get to know me.`);
        joe.talk(`Well, it's fine that she wants to know you, but why lie about that?`);
        mc.talk(`I don't know... I went to the bar without knowing that.`);
    }
    joe.talk(`And then she met that bartender?`);
    mc.talk(`Yes.`);
    await joe.setQuestion(new Question({ text: `Keep going.\nTell me what happened.`, key: `v3JoeGymWhoFlirted` })
        .option({ title: `She flirted with him`, key: "sheFlirted" })
        .option({ title: `He flirted with her`, key: "chrisFlirted" })
        .option({ title: `They both flirted with each other`, key: "bothFlirted" }));


    if (Question.globalAnswers.v3JoeGymWhoFlirted === "sheFlirted") {

        mc.talk(`She flirted with him...`);
        joe.talk(`That slut!`);
        joe.talk(`Did you say something?`);
        mc.talk(`No. I didn't know her.\nI kept quiet.`);
    } else if (Question.globalAnswers.v3JoeGymWhoFlirted === "chrisFlirted") {

        mc.talk(`He flirted with her.`);
        joe.talk(`That makes sense... She is hot, I'd have been more surprised if he hadn't.`);
    } else {

        mc.talk(`They both flirted with each other...`);
        joe.talk(`That slut!`);
        joe.talk(`Did you say something?`);
        mc.talk(`No. I didn't know her.\nSo I kept quiet.`);
    }

    joe.talk(`Go on.`);
    mc.talk(`Well, we just talked.`);
    mc.talk(`She asked me about Ann.\nI asked her a few questions and then I left the bar.`);
    mc.talk(`She said she was going to finish her drink before leaving.`);
    mc.talk(`I had a weird feeling. So before I went home, I took a second look around the corner.`);
    mc.talk(`I saw her and bartender sitting and chatting.`);
    joe.talk(`Did you see anything else?`);
    mc.talk(`No, I just left.`);
    joe.talk(`Well, I can't blame you.\nYou didn't do anything wrong.`);
    joe.talk(`I would have appreciated if you told me before, but I get it.`);
    if (Question.globalAnswers.v3JoeGymTellAboutBarGift) {

        joe.talk(`You didn't want to ruin my birthday present.`);
    }

    return jump(JoeGym3ConfessClothesQuestion, "JoeGym3ConfessClothesQuestion");

};


export const JoeGym3ConfessClothesQuestion = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym7);
    await mc.setQuestion(new Question({ text: `He doesn't even know I went to her place and she tried on some clothes in front of me...`, options: { think: true }, key: `v3JoeGymTellHimVanessaClothesHouse` })
        .option({ title: `Tell him`, key: true })
        .option({ title: `Don't tell him`, key: false }));


    if (Question.globalAnswers.v3JoeGymTellHimVanessaClothesHouse) {
        return jump(JoeGym3Confess1Clothes, "JoeGym3Confess1Clothes");
    } else {
        return jump(JoeGym3Confess1NotClothes, "JoeGym3Confess1NotClothes");
    }
};

export const JoeGym3Confess1Clothes = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym6);
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {

        mc.talk(`There is one more thing...`);
    } else {

        mc.talk(`Joey, there is something I think you should know.`);
        joe.talk(`What is it?`);
    }

    mc.talk(`Remember that day when you left me alone with Vanessa at the beach?`);

    joe.talk(`I do, I came here to work out.`);
    mc.talk(`So, Vanessa asked me to join her at her place.`);

    joe.talk(`Did you do anything???`);
    mc.talk(`No!`);
    mc.talk(`She was just trying out some clothes for your birthday.`);
    mc.talk(`She said she needed my help because you and I are best friends and I might know what you like.`);
    joe.talk(`Did you help her?`);

    if (Question.globalAnswers.v2VanessaDressLikedTheMost === "white") {

        mc.talk(`Yes, I even helped her choose a white dress.`);
    } else if (Question.globalAnswers.v2VanessaDressLikedTheMost === "black") {

        mc.talk(`Yes, I even helped her choose a black dress.`);
    } else {

        mc.talk(`Yes, I even helped her choose a black and red dress.`);
    }
    joe.talk(`I'll act surprised when I see it.`);
    mc.talk(`That's not the point.`);
    mc.talk(`She was acting all flirty.`);
    mc.talk(`She kept talking about her cleavage and lifted up her dress and asked me if it was too short.`);
    joe.talk(`That's not new... I've just told you that's how she acts.`);
    joe.talk(`I can't say that I like it but at least it was with someone I trust.`);
    mc.talk(`You didn't really care that she was exposing herself during the truth or dare game.`);
    joe.talk(`No, because I was there.`);
    mc.talk(`Got it.`);

    return jump(JoeGym3Confess2, "JoeGym3Confess2");
};

export const JoeGym3Confess1NotClothes = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym6);

    if (Question.globalAnswers.v3JoeGymTellAboutBarGift) {

        mc.talk(`Yeah, I didn't want to ruin it.`);
        joe.talk(`You are a great friend ${mc.name}.`);
    } else {

        mc.think(`He is in a bad mood as it is, I don't want to make it worse.`);
    }
    return jump(JoeGym3Confess2, "JoeGym3Confess2");

};


export const JoeGym3Confess2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym7);
    // TODO: refactor this at vanessa scene
    if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain !== "blackmailHer") {
        joe.talk(`We've talked enough about me.`);

        joe.talk(`Is there anything you want to tell me?`);
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            mc.talk(`There is this one thing.`);
            mc.talk(`We didn't really have the chance to talk before so I didn't tell you.`);
            mc.talk(`When I went to the bar with Ann, the bartender there hit on her.`);
            joe.talk(`What the fuck? Why didn't you tell him to fuck off?`);
            mc.talk(`I gave him my permission.`);
            joe.talk(`Oh...`);
            if (mc.properties.annStatus === "hate") {
                joe.talk(`Well, Ann is mad at you right now so don't be surprised if you find them hooking up.`);
                if (Question.globalAnswers.v3JoeGymWhyDislikeAnn !== "IChangedMyMind") {
                    joe.talk(`But since you don't even like her I don't see that as a problem.`);
                    mc.talk(`It's not.`);
                    joe.talk(`So why did you tell me that?`);
                    mc.talk(`I felt like I needed to share something as well.`);
                } else {
                    joe.talk(`And since you've changed your mind about her, he might cause a problem for you.`);
                    mc.talk(`I agreed that he will have her number, I'll deal with the consequences.`);
                    joe.talk(`If you need anything, just tell me!`);
                    mc.talk(`Thanks Joey.`);
                }

            } else if (mc.properties.annStatus === "gf") {
                joe.talk(`Why?`);
                mc.talk(`I just did.`);
                mc.talk(`I'll deal with that when the time comes.`);
                joe.talk(`Alright ${mc.name}, I trust you.`);
            }



        } else {

            mc.talk(`No, there isn't anything.`);
            joe.talk(`Great, so I'll continue my workout.`);
            joe.talk(`Thanks for coming ${mc.name}.`);
            joe.talk(`If you want to come here regularly and work out just say the word and I'll build an exercise plan for you.`);
            mc.talk(`Thanks.\nCya Joey.`);

        }




    } else if (mc.properties.vanessaStatus === "blackmailAttempt") {

        mc.think(`There is no point in telling Joey I tried to blackmail Vanessa.`);
        mc.think(`I already said too much, I don't want him to get hurt anymore.`);
    } else if (!Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {

        mc.think(`Well, since I backed off from blackmailing Vanessa, there is no point in telling.`);
        mc.think(`I don't want to hurt Joey's feeling anymore.`);
    } else if (mc.properties.vanessaStatus === "blackmail") {
        await mc.setQuestion(new Question({ text: `I did blackmail Vanessa...`, options: { think: true }, key: `v3JoeGymWhoTellAboutBlackmail` })
            .option({ title: `Tell him`, key: true })
            .option({ title: `Don't tell him`, key: false }));

        if (Question.globalAnswers.v3JoeGymWhoTellAboutBlackmail) {
            await mc.set((properties) => {
                properties.joeStatus = "enemy";
            });
            return jump(JoeGym3Confess1ToldBlackmailed, "JoeGym3Confess1ToldBlackmailed");
        } else {
            return jump(JoeGym3Confess1DidntTellJoeyBlackmailed, "JoeGym3Confess1DidntTellJoeyBlackmailed");
        }
    }

    return jump(AfterJoeGymConversation, "AfterJoeGymConversation");
};


export const JoeGym3Confess1ToldBlackmailed = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym7);
    mc.think(`I need to tell him, he is my best friend.`);
    mc.think(`I can't let Vanessa have leverage over me...`);
    mc.think(`I must tell him.`);

    mc.talk(`Joey.`);
    mc.talk(`It doesn't stop there...`);
    joe.talk(`Why are you so dramatic?\nWhat is it?`);
    mc.talk(`I know what she did with the bartender... She gave him a blowjob.`);

    joe.talk(`That bitch!`);
    joe.talk(`But I'm not stupid, I knew it was something like that.`);
    joe.talk(`Vanessa is too much of a slut to just kiss someone.`);
    mc.think(`Wow... the way he talks about his girl...`);
    joe.talk(`Hold on a second.\nHow do you know?`);
    mc.think(`Here it comes...`);
    mc.talk(`After I met with her, I was curious so I had to go back to the bar and check.`);
    mc.talk(`I had a talk with Chris, the bartender.`);
    mc.talk(`He showed me a picture of her on his phone...`);
    joe.talk(`What kind of a picture?`);
    mc.talk(`She was smiling... Holding his cock...`);
    mc.talk(`She didn't seem like she cared being filmed.`);
    joe.talk(`That bitch...`);
    joe.talk(`Why didn't you tell me sooner?`);
    mc.talk(`I tried.\nRemember yesterday? When you asked for my permission to fool around with Ann?`);
    mc.talk(`I tried to tell you.`);
    joe.talk(`Oh, I see.`);
    mc.talk(`But that's not why I'm telling you this now.`);

    joe.talk(`Damn dude, is there more?`);
    mc.talk(`Listen, I think I made a huge mistake.`);
    mc.think(`I was stupid enough to think I have leverage over her.`);
    mc.talk(`And the way she was teasing me lately I had this stupid idea...`);


    mc.talk(`I told her that I'll keep quiet about everything if she gives me something.`);
    joe.talk(`What the fuck ${mc.name}??`, { method: "Shouting" });
    joe.talk(`What did you do???`, { method: "Shouting" });

    mc.talk(`I used the information I had and forced her to give me a blowjob...`);
    joe.talk(`You better be joking with me right now.`);
    mc.talk(`I'm not.`);
    joe.talk(`I don't know if that's a sick joke.`);
    mc.talk(`It's not.`);
    joe.talk(`You better get the fuck out of my sight.`);
    mc.talk(`Joey.`);
    joe.talk(`Fuck off.`);
    mc.talk(`Joey...`);
    ImageClass.setImage(images.v3.JoeyGym8);
    joe.talk(`FUCK OFF!`, { method: "Shouting" });
    mc.think(`I shouldn't have expected less...`);
    mc.think(`I better be going.`);
    return jump(AfterJoeGymConversation, "AfterJoeGymConversation");
};

export const JoeGym3Confess1DidntTellJoeyBlackmailed = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym7);
    mc.talk(`That's all.`);
    joe.talk(`Well, I learned some new things.`);
    joe.talk(`But it's not that bad.`);
    joe.talk(`It's been a while since we've had a heart-to-heart conversation.`);
    joe.talk(`I've been so busy, I kinda missed it.`);
    mc.talk(`Yeah, it's nice.`);
    mc.talk(`I'm gonna go now and leave you to continue working out.`)
    return jump(AfterJoeGymConversation, "AfterJoeGymConversation");

};

export const JoeGym3DontConfess1 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.JoeyGym6, { transition: true });
    mc.think(`He has no idea I was at the bar with Vanessa and I'm going to keep it that way.`);
    mc.think(`Joey has been a great friend of mine for many years, I don't want to risk our friendship.`);
    mc.think(`I'll just stay quiet for now.`);

    joe.talk(`You remember it's my birthday tomorrow right?`);
    mc.talk(`How can I forget? You keep reminding me haha.`);
    mc.talk(`Are you planning something?`);
    joe.talk(`I'm not sure yet, Vanessa says she has a surprise for me.`);
    joe.talk(`But maybe we can do something after.`);
    joe.talk(`Would you come?`);
    mc.talk(`Of course, just tell me when and where and I'll be there.`);
    joe.talk(`Again, it's not certain but I want to arrange something.`);
    joe.talk(`Maybe you can bring Ann as well.`);
    mc.talk(`I'll think about it.`);

    return jump(AfterJoeGymConversation, "AfterJoeGymConversation");
};

export const AfterJoeGymConversation = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomAlone_2, { transition: true });
    if (Question.globalAnswers.v3JoeGymTellAboutGoingBarWithVanessa === false) {

        mc.think(`That was a missed opportunity.`);
        mc.think(`I didn't tell Joe I was really with Vanessa the other day at the bar.`);
        mc.think(`I just hope he won't get mad if he finds out.`);
    }
    if (Question.globalAnswers.v3JoeGymTellHimVanessaClothesHouse === false) {

        mc.think(`I decided not to tell him about Vanessa flirting with me at her place.`);
        mc.think(`It could really hurt their relationship.`);
        mc.think(`I wouldn't want to do that now, certainly not when his birthday is tomorrow.`);
    }
    if (mc.properties.joeStatus === "enemy") {
        mc.think(`That was a fucking train wreck...`);
        mc.think(`What was I thinking?`);
        mc.think(`I just hope he won't stay mad forever...`);
        mc.think(`I told him about that just so Vanessa couldn't drive a wedge between Joe and I, and in the end I did that myself.`);
    } else {
        if ((Question.globalAnswers.v3JoeGymTellAboutGoingBarWithVanessa || Question.globalAnswers.v3JoeGymTellHimVanessaClothesHouse)) {
            mc.think(`That went quite well, I got some things off my chest.`);
            mc.think(`Plus, I've learned some new things about their relationship.`);
        }
    }


    if (Game.seenScenarios.includes(`VanessaCoffee1`) || Game.seenScenarios.includes('AnnAfterTODLove1')) {

        return jump(RoomAfterEventsBTNS, "RoomAfterEventsBTNS");
    } else {

    }
    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};


